import { render } from "./InvoicesList.vue?vue&type=template&id=2de9659a&scoped=true"
import script from "./InvoicesList.vue?vue&type=script&lang=js"
export * from "./InvoicesList.vue?vue&type=script&lang=js"

import "./InvoicesList.vue?vue&type=style&index=0&id=2de9659a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de9659a"]])

export default __exports__